import { render, staticRenderFns } from "./TabProductDetailPanel.vue?vue&type=template&id=3247940a&scoped=true"
import script from "./TabProductDetailPanel.vue?vue&type=script&lang=js"
export * from "./TabProductDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./TabProductDetailPanel.vue?vue&type=style&index=0&id=3247940a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247940a",
  null
  
)

export default component.exports